import api from './client';

export const creditApi = {
  worklist:    (params?: any)      => api.get('/credit/worklist', { params }),
  salespeople: ()                  => api.get('/credit/salespeople'),
  history:     (contactId: number) => api.get(`/credit/history/${contactId}`),
  record:      (data: any)         => api.post('/credit/follow-ups', data),
  settings:     (id: number)           => api.get(`/credit/settings/${id}`),
  saveSettings: (id: number, data: any) => api.put(`/credit/settings/${id}`, data),
};
